(function ($) {
	'use strict';

	function track(payload) {
		window.dataLayer = window.dataLayer || [];
		try { window.dataLayer.push(payload); } catch (e) { /* swallow */ }
	}

	function getResourceContext($el) {
		var $card = $el.closest('.card_content');
		return {
			resource_id: $.trim($card.find('.favourite_toggle').attr('id') || ''),
			resource_title: $.trim($card.find('.col-8.content > h3').first().text())
		};
	}

	$(document).on('click', '#cross-hub-nav a.hub', function () {
		var clickedLink = $(this);
		var url = clickedLink.attr('href');

		// SOURCE HUB (current page)
		var sourceHub = window.location.hostname;

		// DESTINATION HUB (from clicked URL)
		var destinationHub;
		try {
			destinationHub = new URL(url, window.location.origin).hostname;
		} catch (e) {
			destinationHub = url;
		}

		// Push to GTM dataLayer
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'cross_hub_nav_click',
			source_hub: sourceHub,
			destination_hub: destinationHub,
			nav_location: 'header_cross_hub_nav'
		});
	});

	$(document).on('click', '#resources-result .card_bottom a.primary_btn', function () {
		var ctx = getResourceContext($(this));
		track({
			event: 'resource_view',
			resource_id: ctx.resource_id,
			resource_title: ctx.resource_title,
			resource_url: $(this).attr('href')
		});
	});
}(jQuery));
